var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('floating-menu',{attrs:{"event-id":_vm.eventId}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('event-report-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }